const protectedProps = ['alias', 'slot', 'uuid', 'onMount', 'onUnmount'];
function getLostProps(propTypes, props) {
    const empty = {};
    if (!propTypes) {
        return empty;
    }
    const entries = Object.entries(props);
    return entries
        .filter(([key]) => !protectedProps.includes(key))
        .reduce((result, [key, value]) => {
        return key in propTypes
            ? result
            : { ...result, [key]: value };
    }, empty);
}
export default getLostProps;
//# sourceMappingURL=get-lost-props.js.map